import { styled } from '@mui/material/styles';

export const EditorRoot = styled('div')(({ theme }) => ({
  width: '100%',
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: 4,
  backgroundColor: theme.palette.background.paper,
  display: 'flex',
  flexDirection: 'column',
}));

export const Toolbar = styled('div')(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  gap: 2,
  padding: theme.spacing(0.5),
  borderBottom: `1px solid ${theme.palette.divider}`,
  backgroundColor: theme.palette.action.disabledBackground,
}));

export const ToolbarButton = styled('button', {
  shouldForwardProp: (prop) => prop !== 'isActive',
})(({ theme, isActive }) => ({
  border: 'none',
  background: isActive ? theme.palette.action.selected : 'transparent',
  color: isActive ? theme.palette.primary.main : theme.palette.text.primary,
  cursor: 'pointer',
  padding: '4px 6px',
  borderRadius: 3,
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  minWidth: 28,
  minHeight: 28,
  fontSize: 18,
  lineHeight: 1,
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
  },
  '&:disabled': {
    cursor: 'default',
    opacity: 0.4,
  },
}));

export const ToolbarDivider = styled('span')(({ theme }) => ({
  display: 'inline-block',
  width: 1,
  height: 20,
  margin: '0 4px',
  backgroundColor: theme.palette.divider,
}));

export const EditorBody = styled('div')(({ theme }) => ({
  padding: theme.spacing(1.5),
  minHeight: 120,
  backgroundColor: theme.palette.background.paper,
  color: theme.palette.text.primary,
  '& .ProseMirror': {
    outline: 'none',
    minHeight: 100,
    '& p.is-editor-empty:first-of-type::before': {
      content: 'attr(data-placeholder)',
      float: 'left',
      color: theme.palette.text.disabled,
      pointerEvents: 'none',
      height: 0,
    },
    '& p': {
      margin: '0 0 0.5em',
    },
    '& h1, & h2, & h3': {
      margin: '0.5em 0 0.25em',
    },
    '& ul, & ol': {
      paddingLeft: 24,
    },
    '& blockquote': {
      borderLeft: `3px solid ${theme.palette.divider}`,
      paddingLeft: 12,
      color: theme.palette.text.secondary,
      margin: '0.5em 0',
    },
    '& code': {
      background: theme.palette.action.hover,
      padding: '1px 4px',
      borderRadius: 3,
      fontSize: '0.95em',
    },
    '& pre': {
      background: theme.palette.action.hover,
      padding: theme.spacing(1),
      borderRadius: 4,
      overflowX: 'auto',
    },
    '& mark': {
      background: 'rgba(255, 235, 59, 0.5)',
      padding: '0 2px',
      borderRadius: 2,
    },
    '& a': {
      color: theme.palette.primary.main,
      textDecoration: 'underline',
    },
    '& img': {
      maxWidth: '100%',
    },
  },
}));
